/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Meta_DescriptionInputs */

const en_svc_rag_meta_description = /** @type {(inputs: Svc_Rag_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom RAG systems and AI knowledge bases built on your documents: internal AI assistants and customer support chatbots that answer with sources.`)
};

const lv_svc_rag_meta_description = /** @type {(inputs: Svc_Rag_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pielāgotas RAG sistēmas un AI zināšanu bāzes no Jūsu dokumentiem: iekšējie AI asistenti un klientu atbalsta čatboti, kas atbild ar avotiem.`)
};

/**
* | output |
* | --- |
* | "Custom RAG systems and AI knowledge bases built on your documents: internal AI assistants and customer support chatbots that answer with sources." |
*
* @param {Svc_Rag_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_meta_description = /** @type {((inputs?: Svc_Rag_Meta_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Meta_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_meta_description(inputs)
	return en_svc_rag_meta_description(inputs)
});